// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e6cbdb84","729":"9751ce3c","770":"547c0edf","918":"9689b463"}[chunkId] + ".chunk.js";
};